import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import ConfirmationStep from '../../steps/ConfirmationStep';

export default function buildConfirmationConfiguration({
  toggleMenu,
  WarningComponent,
  warningComponentProps,
}) {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.OPERATION_CONFIRMATION,
    title: '¡Listo!',
    component: ConfirmationStep,
    props: { toggleMenu, WarningComponent, warningComponentProps },
  };
}
